export default "__VITE_ASSET__9PtYckIp__"